"use client";
import { useRouter, usePathname } from "next/navigation";
import { getCityFromUrl, generateCityUrl } from "@/lib/cityUtils";
import { formateCityName } from "@/lib/formateCityName";

interface HomePageRedirectBtnProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  [key: string]: unknown; // Allow additional props
}

const HomePageRedirectBtn: React.FC<HomePageRedirectBtnProps> = ({
  children,
  className = "",
  ...props
}) => {
  const router = useRouter();
  const pathname = usePathname();

  const handleClick = () => {
    // Preserve selected city when going back to "home" from listing/search
    const cityFromUrl = getCityFromUrl(pathname);
    if (cityFromUrl.name) {
      router.push(generateCityUrl(cityFromUrl.name, "bike-rentals"));
      return;
    }
    // If no city in URL (e.g. on /about-us), try last selected city from localStorage
    try {
      const saved = localStorage.getItem("selectedCity");
      if (saved) {
        const parsed = JSON.parse(saved);
        const cityName = parsed?.label ?? parsed?.value ?? parsed?.name;
        if (cityName && typeof cityName === "string") {
          const formatted = formateCityName(cityName.trim());
          if (formatted) {
            router.push(generateCityUrl(formatted, "bike-rentals"));
            return;
          }
        }
      }
    } catch {
      // ignore
    }
    router.push("/");
  };

  return (
    <button
      className={`cursor-pointer ${className}`}
      onClick={handleClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default HomePageRedirectBtn; 